module.exports = __webpack_public_path__ + "static/media/icon_56.165694e9.svg";